import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeTitleBanner } from '../../store/actions';
import { getRouteNameFromURL } from '../../helpers/routing_helper';

export default (pathname: string) => {
    const dispatch = useDispatch();

    const [pageTitle, setPageTitle] = useState('');

    useEffect(() => {
        const name = getRouteNameFromURL(pathname, []);

        setPageTitle(name);
    }, [pathname]);

    useEffect(() => {
        dispatch(changeTitleBanner(pageTitle.replace(/-/g, ' ')))
    },[pageTitle]);

    return pageTitle;
};
